
const featureFlags = {
    home: {
        showTrustedCustomers: false,
        showTestimonials: false,
    },
    contactUs: {
        showSocialMediaLinks: false,
    },
    legal: {
        showDemoLink: false,
        showWhatYouCanAccomplish: false,
    },

}

export default featureFlags;